import { ref, firebaseAuth } from '../config/constants'
var firebase = require('firebase')

export function googleSignIn () {

  return firebaseAuth().signInWithPopup(new firebase.auth.GoogleAuthProvider());
}
export function auth (email, pw) {
  return firebaseAuth().createUserWithEmailAndPassword(email, pw)
    .then(saveUser)
}

export function logout () {
  return firebaseAuth().signOut()
}

export function login (email, pw) {
  return firebaseAuth().signInWithEmailAndPassword(email, pw)
}

export function resetPassword (email) {
  return firebaseAuth().sendPasswordResetEmail(email)
}

export function saveUser (user) {
  return ref.child(`users/${user.uid}/info`)
    .set({
      email: user.email,
      uid: user.uid
    })
    .then(() => user)
}



// WEBPACK FOOTER //
// ./src/helpers/auth.js